import React from 'react'

import TextField, { TextFieldProps } from '@material-ui/core/TextField'

import T from 'components/FormattedMessage'

const OnboardingPasswordField: React.SFC<TextFieldProps> = ({ variant, ...props }) => {
  return (
    <TextField
      type="password"
      label={<T id="onboarding_login_passwordplaceholder">{(text) => text}</T>}
      variant="outlined"
      margin="dense"
      fullWidth
      required
      {...props}
    />
  )
}

export default OnboardingPasswordField
